import {GetActiveMissionsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import React from 'react';
import {
  MissionBadge,
  MissionBadgeProps,
} from '../../../features/Coins/MissionBadge/MissionBadge';
import {MissionType} from '../utils/missionType';
import {useGetActiveMissionByType} from '../utils/useGetActiveMissions';

interface MissionBadgeViewProps
  extends GetActiveMissionsResponse,
    Omit<MissionBadgeProps, 'reward'> {
  missionType: MissionType;
}

export const MissionBadgeView: React.FC<MissionBadgeViewProps> = ({
  missionType,
  ...rest
}) => {
  const selectedMission = useGetActiveMissionByType({mission: missionType});

  if (!selectedMission) {
    return null;
  }

  return <MissionBadge {...rest} reward={selectedMission.reward} />;
};
